import { render, staticRenderFns } from "./others-polarBar.md?vue&type=template&id=a7de8482&"
import script from "./others-polarBar.md?vue&type=script&lang=js&"
export * from "./others-polarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7de8482')) {
      api.createRecord('a7de8482', component.options)
    } else {
      api.reload('a7de8482', component.options)
    }
    module.hot.accept("./others-polarBar.md?vue&type=template&id=a7de8482&", function () {
      api.rerender('a7de8482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/PolarBar/others-polarBar.md"
export default component.exports